// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paper-turn-book-content{height:100%;width:100%}.paper-turn-book-content .paper-turn-wrapper{display:flex;justify-content:center;padding:30px 0}.paper-turn-book-content .paper-turn-top{display:flex;height:83%;overflow-x:auto;overflow-y:hidden}.paper-turn-book-content.pc.width67{width:67%}.paper-turn-book-content img{z-index:1}.paper-turn-book-content .jump-btn{cursor:pointer}.paper-turn-book-content .el-drawer__wrapper{position:static!important;height:200px}", ""]);
// Exports
module.exports = exports;
